var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view tab-bill-payment" },
    [
      _c(
        "query-bill-payment",
        {
          ref: "queryBillPayment",
          attrs: {
            "is-append-query": _vm.isAppendQuery,
            identify: "queryBillPayment",
            "view-source": "billPaymentList",
            "show-real-clearing-state":
              _vm.searchConditions.showRealClearingState,
            state: _vm.searchConditionsState,
            "paid-off": _vm.searchConditionsPaidOff,
            "is-check-charge": _vm.searchConditions.isCheckCharge,
            "show-controlled-charge": _vm.searchConditions.showControlledCharge,
            "show-fba": false,
            "input-date-start": _vm.searchConditions.inputDateStart,
            "input-date-end": _vm.searchConditions.inputDateEnd,
            "clearing-states": _vm.searchConditionsClearingStates,
            "show-wht": _vm.showWht,
            "config-module": "508",
            "is-bpm": true,
            "grid-config-module": "190801"
          },
          on: {
            rowDoubleClicked: _vm.rowDoubleClicked,
            toSearchTemplate: _vm.toSearchTemplate
          },
          scopedSlots: _vm._u([
            {
              key: "other",
              fn: function() {
                return [
                  _c(
                    "el-form",
                    {
                      staticStyle: { "margin-right": "15px" },
                      attrs: {
                        inline: true,
                        "label-width": "60px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "el-form-item-search",
                          attrs: {
                            label: _vm.$t("Billing.billingJob_billPaymentDate")
                          }
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { "label-width": "0" } },
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: { "margin-right": "0px" },
                                        attrs: {
                                          type: "date",
                                          clearable: false,
                                          "value-format": "yyyy-MM-dd",
                                          "picker-options": _vm.pickerOptions
                                        },
                                        model: {
                                          value:
                                            _vm.searchConditions.inputDateStart,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.searchConditions,
                                              "inputDateStart",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "searchConditions.inputDateStart"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("el-col", { attrs: { span: 2 } }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("Billing.billingJob_dateTo"))
                                  )
                                ])
                              ]),
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { "label-width": "0" } },
                                    [
                                      _c("el-date-picker", {
                                        attrs: {
                                          type: "date",
                                          clearable: "",
                                          "value-format": "yyyy-MM-dd",
                                          "picker-options": _vm.pickerOptions
                                        },
                                        model: {
                                          value:
                                            _vm.searchConditions.inputDateEnd,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.searchConditions,
                                              "inputDateEnd",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "searchConditions.inputDateEnd"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { "label-width": "0" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          model: {
                                            value: _vm.allowTwoYearOutside,
                                            callback: function($$v) {
                                              _vm.allowTwoYearOutside = $$v
                                            },
                                            expression: "allowTwoYearOutside"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "Billing.billingJob_lockCheckBoxDate"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "div",
            { attrs: { slot: "operations" }, slot: "operations" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.toDetail(false, null)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.viewDetails_SR")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: [0, 1, 2, 3, 4].includes(_vm.applicationStatus),
                      expression: "[0, 1, 2, 3, 4].includes(applicationStatus)"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.toCollectInvoice }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.collectInvoice")))]
              ),
              _c(
                "el-dropdown",
                {
                  staticStyle: { margin: "0 5px" },
                  attrs: { "split-button": "", type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.toPrint(_vm.$t("Payment.print"))
                    },
                    command: _vm.toPrint
                  }
                },
                [
                  _vm._v(" " + _vm._s(_vm.$t("Payment.print")) + " "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: _vm.$t(
                              "Clearing.PrintByPaymentRequestNumber"
                            )
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Clearing.PrintByPaymentRequestNumber")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: [0, 1, 2, 3, 4].includes(_vm.applicationStatus),
                      expression: "[0, 1, 2, 3, 4].includes(applicationStatus)"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.toCreatePayment }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.newPaymentRequest")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: [1].includes(_vm.applicationStatus),
                      expression: "[1].includes(applicationStatus)"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.doCommit }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.submit")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        [1, 4].includes(_vm.applicationStatus) &&
                        this.$checkPermission([
                          "button_ACPayAuthBpm_btnBillDelete"
                        ]),
                      expression:
                        "[1, 4].includes(applicationStatus) && this.$checkPermission(['button_ACPayAuthBpm_btnBillDelete'])"
                    }
                  ],
                  attrs: { type: "danger" },
                  on: { click: _vm.doDelete }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.delete")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.paymentChange && _vm.applicationStatus === 2,
                      expression: "paymentChange && applicationStatus === 2"
                    }
                  ],
                  attrs: { no: "12", type: "primary" },
                  on: { click: _vm.toBatchChangeTime }
                },
                [_vm._v(_vm._s(_vm.$t("Payment.changePaymentRequest")))]
              )
            ],
            1
          )
        ]
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          },
          selectedTemplate: _vm.updatePrintField
        }
      }),
      _c("make-invoice-dialog", {
        ref: "invoice",
        attrs: { "view-source": "billPaymentList", location: "location" },
        on: { reloadData: _vm.reloadData }
      }),
      _vm.changePaymentDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "changePaymentRequest",
              attrs: {
                visible: _vm.changePaymentDialog.visible,
                title: _vm.$t("CargoMsg.Cargo_ChangePayment"),
                width: "450px",
                height: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.changePaymentDialog, "visible", $event)
                }
              }
            },
            [
              [
                _c("div", [
                  _c(
                    "div",
                    {
                      staticClass: "dialog-body",
                      staticStyle: {
                        "padding-left": "10px",
                        "padding-top": "20px",
                        "padding-bottom": "26px"
                      }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("span", { staticClass: "name" }, [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_PaymentTimeLimit"))
                            )
                          ]),
                          _c("el-date-picker", {
                            attrs: {
                              clearable: false,
                              editable: false,
                              type: "date"
                            },
                            model: {
                              value: _vm.changePaymentDialog.deadLine,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.changePaymentDialog,
                                  "deadLine",
                                  $$v
                                )
                              },
                              expression: "changePaymentDialog.deadLine"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-top": "7px", display: "flex" }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "name",
                              staticStyle: {
                                width: "25px",
                                "margin-left": "23px"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Remarks")))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column"
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "220px" },
                                attrs: { type: "textarea", rows: 5 },
                                model: {
                                  value: _vm.changePaymentDialog.remark,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.changePaymentDialog,
                                      "remark",
                                      $$v
                                    )
                                  },
                                  expression: "changePaymentDialog.remark"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { "margin-top": "7px" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_BillPaymentRemarkTip"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      staticStyle: { "justify-content": "right" },
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.changePaymentConfirm }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function($event) {
                              _vm.changePaymentDialog.visible = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                      )
                    ],
                    1
                  )
                ])
              ]
            ],
            2
          )
        : _vm._e(),
      _c("batch-submit-or-approve-dialog", {
        attrs: {
          visible: _vm.batchSubmitOrApproveDialog.visible,
          "row-data": _vm.batchSubmitOrApproveDialog.rowData,
          "is-submit": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchSubmitOrApproveDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }